export default __webpack_public_path__ + "static/gptw-085843ec921a64210e1fbbea97e14d75.png";